module.exports = __webpack_public_path__ + "img/b4c8a2648f01940b3c3c6c3a8a120e7c.png";